import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import { useAdmin } from '../../context/AdminContext';

const AdminLayout = ({ children }) => {
  const { isAuthenticated, loading } = useAdmin();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true); // Default to true for desktop

  useEffect(() => {
    // Add admin-area class to body when AdminLayout mounts
    document.body.classList.add('admin-area');
    
    // Set sidebar state based on screen size
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSidebarOpen(false); // Collapse on mobile by default
      } else {
        setSidebarOpen(true); // Expand on desktop
      }
    };
    
    // Call once on mount
    handleResize();
    
    // Add resize listener
    window.addEventListener('resize', handleResize);
    
    // Clean up on unmount
    return () => {
      document.body.classList.remove('admin-area');
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // If location changes, scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 admin-area">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`admin-layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      <AdminSidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div className="admin-content">
        <AdminHeader toggleSidebar={toggleSidebar} />
        <main className="p-4">
          {children}
        </main>
      </div>
      
      <style jsx="true">{`
        .admin-layout {
          display: flex;
          min-height: 100vh;
          width: 100%;
          position: relative;
        }
        
        .admin-content {
          flex: 1;
          width: 100%;
          transition: margin-left 0.3s ease;
          overflow-x: hidden;
        }
        
        .sidebar-open .admin-content {
          margin-left: 250px;
        }
        
        .sidebar-closed .admin-content {
          margin-left: 60px;
        }
        
        @media (max-width: 768px) {
          .sidebar-open .admin-content {
            margin-left: 0;
            padding-left: 250px;
          }
          
          .sidebar-closed .admin-content {
            margin-left: 0;
            padding-left: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default AdminLayout;
